import useSWR from 'swr';
import { useToken } from '../Provider/TokenProvider';

const url = `${process.env.ENERGYSHOP_DOMAIN ?? process.env.NEXT_PUBLIC_ENERGYSHOP_DOMAIN}/api/`;

const endpoints = {
  offers: 'calc/offers',
  offersOekoSpecificPrice: 'calc/offers/electric/price',
  features: 'calc/features',
  rules: 'calc/rules',

  checkoutToken: 'checkouts',
  details: 'checkouts/',
  submit: 'checkouts//submit',
  sideselling: 'checkouts//sideselling',
  checkoutDelete: 'checkouts//delete',

  products: 'products',

  validate: 'validate',
};

const headers = {
  'Authorization-Token': `Token ${
    process.env.ENERGYSHOP_TOKEN ?? process.env.NEXT_PUBLIC_ENERGYSHOP_TOKEN
  }`,
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

const getUrl = (token: string | undefined, endpoint: string) => {
  let requestPath = endpoint;
  if (token) {
    requestPath = requestPath.replace('checkouts/', `checkouts/${token}`);
  }
  return url + requestPath;
};

const client = async (path: string, options: Partial<RequestInit> | undefined = undefined) => {
  const response = await fetch(url + path, {
    method: 'GET',
    ...options,
    headers: {
      ...options?.headers,
      ...headers,
    },
  });

  if (!response.ok) {
    throw Error('Fehler');
  }
  return response.json();
};

function useApi<T>(
  endpoint: string,
  params?: Partial<RequestInit>,
  config?: Record<string, any>,
  enable = true,
) {
  const { token } = useToken();

  let requestPath = endpoint;
  if (token) {
    requestPath = requestPath.replace('checkouts/', `checkouts/${token}`);
  }

  let cacheKey: null | string = null;
  if (enable) {
    if (params?.method) {
      cacheKey = `${endpoint}_${token}`;
    } else {
      cacheKey = `${endpoint}_${token}_${JSON.stringify(params)}`;
    }
  }

  const query = useSWR<T>(cacheKey, async () => client(requestPath, params), {
    loadingTimeout: 3000,
    ...config,
  });
  return query;
}

export { endpoints, getUrl, headers, useApi };
